<template>
    <d-list-group-item class="p-3" v-if="fetched">
        <d-form-row>
            <d-col md="12" class="form-group">
                <label>Nip: </label>
                <strong> {{ client.invoice_tax_number }}</strong><br />
                <label>Nazwa: </label>
                <strong> {{ client.invoice_name }}</strong>
            </d-col>
        </d-form-row>
        <d-form-row>
            <d-col md="6" class="form-group">
                <label for="invoice_street">Ulica</label>
                <d-input id="invoice_street"
                         type="text"
                         name="invoice_street"
                         v-model="client.invoice_street"
                         @input="lar_errors.clear('invoice_street')"
                         :class="{'is-invalid' : lar_errors.has('invoice_street')}"
                         placeholder="Ulica" />
                <div class="invalid-feedback" v-text="lar_errors.get('invoice_street')"></div>
            </d-col>
            <d-col md="6" class="form-group">
                <label for="invoice_house_number">Nr budynku</label>
                <d-input id="invoice_house_number"
                         type="text"
                         name="invoice_house_number"
                         v-model="client.invoice_house_number"
                         @input="lar_errors.clear('invoice_house_number')"
                         :class="{'is-invalid' : lar_errors.has('invoice_house_number')}"
                         placeholder="Nr budynku" />
                <div class="invalid-feedback" v-text="lar_errors.get('invoice_house_number')"></div>
            </d-col>
        </d-form-row>
        <d-form-row>
            <d-col md="6" class="form-group">
                <label for="invoice_flat_number">Nr lokalu</label>
                <d-input id="invoice_flat_number"
                         type="text"
                         name="invoice_flat_number"
                         v-model="client.invoice_flat_number"
                         @input="lar_errors.clear('invoice_flat_number')"
                         :class="{'is-invalid' : lar_errors.has('invoice_flat_number')}"
                         placeholder="Nr lokalu" />
                <div class="invalid-feedback" v-text="lar_errors.get('invoice_flat_number')"></div>
            </d-col>
        </d-form-row>
        <d-form-row>
            <d-col md="6" class="form-group">
                <label for="name">Kod pocztowy</label>
                <d-input id="invoice_postcode"
                         type="text"
                         name="invoice_postcode"
                         v-mask="'##-###'"
                         v-model="client.invoice_postcode"
                         @input="lar_errors.clear('invoice_postcode')"
                         :class="{'is-invalid' : lar_errors.has('invoice_postcode')}"
                         placeholder="00-000" />
                <div class="invalid-feedback" v-text="lar_errors.get('invoice_postcode')"></div>
            </d-col>
            <d-col md="6" class="form-group">
                <label for="name">Miasto</label>
                <d-input id="invoice_city"
                         type="text"
                         name="invoice_city"
                         v-model="client.invoice_city"
                         @input="lar_errors.clear('invoice_city')"
                         :class="{'is-invalid' : lar_errors.has('invoice_city')}"
                         placeholder="Miasto" />
                <div class="invalid-feedback" v-text="lar_errors.get('invoice_city')"></div>
            </d-col>
        </d-form-row>
    </d-list-group-item>
</template>

<script>
    import LarErrors from '../../helpers/Errors';

    export default {
        name: "InvoiceData",
        components: {
            LarErrors
        },
        props: {
            props: {
                type: Object,
                default: {}
            }
        },
        data(){
            return{
                lar_errors: LarErrors,
                fetched:    false,
                client: {
                    invoice_name:       '',
                    invoice_address:    '',
                    invoice_street:     '',
                    invoice_house_number: '',
                    invoice_flat_number:   '',
                    invoice_city:       '',
                    invoice_postcode:   '',
                    invoice_tax_number: ''
                }
            }
        },
      methods: {

      },
        mounted(){
            this.client = this.props ? this.props : this.client;
            this.fetched = true;
        },
        watch: {
            props: {
                handler: function(to) {
                    this.client = to;
                },
                deep: true
            }
        }
    }
</script>
